import axios from 'axios';
import api from "../../config/_api";
import { AUTH_REQUEST, AUTH_REQUEST_TOKEN, AUTH_REQUEST_TOKEN_FULL, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_STRUCTURE_CHANGE} from '../actions/auth';
import { USER_REQUEST, STRUCTURE_CHANGE} from '../actions/user';

const state = {
    token: sessionStorage.getItem('user-token') || '',
    user: sessionStorage.getItem('user') || '',
    subscribtionValidity: sessionStorage.getItem('subscription') || '',
    status: '',
};

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, credentials) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios({url: api.url + 'users/login', data: credentials, method: 'POST' })
                .then(resp => {
                    const token = resp.data.api_token;
                    sessionStorage.setItem('user-token', token);
                    const user = JSON.stringify(resp.data);
                    sessionStorage.setItem('user', user);
                    
                    //axios.defaults.headers.common['Authorization'] = token;
                    commit(AUTH_SUCCESS, user, token);
                    dispatch(USER_REQUEST);
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('subscription');
                    reject(err)
                })
        })
    },
    [AUTH_REQUEST_TOKEN]: ({commit, dispatch}, token_api_credential) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios({url: api.url + 'users/login', data: token_api_credential, method: 'POST' })
                .then(resp => {
                    const token = resp.data.api_token;
                    sessionStorage.setItem('user-token', token);
                    const user = JSON.stringify(resp.data);
                    sessionStorage.setItem('user', user);
                    
                    //axios.defaults.headers.common['Authorization'] = token;
                    commit(AUTH_SUCCESS, JSON.parse(user), token);
                    dispatch(USER_REQUEST);
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('subscription');
                    reject(err)
                })
        })
    },
    [AUTH_REQUEST_TOKEN_FULL]: ({commit, dispatch}, token_api_credential) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios({url: api.url + 'users/login', data: token_api_credential, method: 'POST' })
                .then(resp => {
                    const token = resp.data.api_token;
                    sessionStorage.setItem('user-token', token);
                    const user = JSON.stringify(resp.data);
                    sessionStorage.setItem('user', user);
                    
                    //axios.defaults.headers.common['Authorization'] = token;
                    commit(AUTH_SUCCESS, JSON.parse(user), token);
                    dispatch(USER_REQUEST);
                    dispatch(STRUCTURE_CHANGE,resp.data.structure[0]);
                    resolve()
                    
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('subscription');
                    reject(err)
                })
        })
    },
    [AUTH_LOGOUT]: ({commit }, full) => {
        return new Promise((resolve ) => {
            commit(AUTH_LOGOUT,full);
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('subscription');
            if(full!=null && full==1){
                sessionStorage.removeItem('user-token');
            }
            // remove the axios default header
            delete axios.defaults.headers.common['Authorization'];
            resolve();
        })
    },
    [AUTH_STRUCTURE_CHANGE]: ({commit}, struct) => {
        return new Promise((resolve ) => {
            var startS = struct.contract_starting_date;
            var endS = struct.contract_ending_date;
            var today = new Date();
            var start = new Date(startS);
            const end = new Date(endS);
            if(today>start && today<end){
                sessionStorage.setItem('subscription', end);
                state.subscribtionValidity = end;
            }
            else{
                sessionStorage.removeItem('subscription');
            }
            commit(AUTH_STRUCTURE_CHANGE);
            resolve();
        })
    }
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, user, token) => {
        state.status = 'success';
        state.token = token;
        state.user = user;
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
    },
    [AUTH_LOGOUT]: (state,full) => {
        state.user = '';
        state.subscribtionValidity = '';
        if(full!=null && full==1){
            state.token = '';
        }
    },
    [AUTH_STRUCTURE_CHANGE]: (state) => {
        state.status = 'subscribtion_updated';
    }
};

const getters = {
    isAuthenticated: state => !!state.user,
    authStatus: state => state.status,
};

export function isSubscriptionValid(){
    if(state.subscribtionValidity != ''){
        var today = new Date();
        var end = new Date(state.subscribtionValidity)
        if(end > today){
            return true;
        }
        else{
            sessionStorage.removeItem('subscription');
            return false;
        }
    }
    else{
        sessionStorage.removeItem('subscription');
        return false;
    }
}

export default {
    state,
    actions,
    mutations,
    getters
};